<template>
    <va-create-layout>
        <ChargebackEvent-form
            :title="title"
            :item="item"
        ></ChargebackEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
